import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);

export const fetchGlobalPermissions = (params) => {
    return axios.get('/api/v1/permissions/get/', { params });
};
